<template>
    <div class="fixed-container d-inline-flex btn-lang-es">
        <router-link :to="{name: 'en'}">
            <button type="submit" class="btn btn-sm btn-outline-light mx-0 rounded-0 border-0">
                <img src="../assets/estados-unidos.svg" width="25" alt="">
            </button>
        </router-link>
    </div>
   

    <categorynewComponent
    v-if="!store.v_success"
    :categories="getters_es" 
    :allergens="getters_allergens_es" 
    id_beer="1" 
    id_wine="34"
    btn_name="VER MÁS"
    ></categorynewComponent>
    

</template>
<script>

import { onMounted,computed, onUpdated } from "vue";
import {useStore} from "vuex";
//import { useRouter } from "vue-router";
//import { useToast } from "vue-toastification";

import categorynewComponent from '@/components/web/categorynewComponent.vue'


import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default {
    name: 'esView',
    components:{
        categorynewComponent
    },
    setup(){
        const store = useStore();
        //const router = useRouter();
        //const toast = useToast();

        const getters_es = computed(() => store.getters.getters_es)
        //const v_error_login = computed(()=> store.state.login.v_error_login)//get data si hay un error en login
        //const v_categories =
        onMounted(() => {
            //console.log(getters_es.value.length)
            if (!store.state.v_success){
                store.dispatch('v_action_categories').then(() => {
               
                });//store
            }//if


            // gsap.to(".btn-lang-es",{
            // scrollTrigger: {
            //     trigger: ".btn-lang-es",
            //     start: "start+=150 center-=270",
            //     end: "bottom+=200 bottom",
            //     //markers: true,
            //     scrub:1,
                
            // },
            // opacity:0
            // })

        })

        onUpdated(()=>{
          console.log('lang actualizado')
        

         

        })

        return{
            store,
            getters_es,
            getters_allergens_es: computed(() => store.getters.getters_allergens_es),
        }
    }
}


</script>